@if (processingService.messages().length) {
    <p-messages [value]="processingService.messages()" [enableService]="false" [closable]="false" />
}

@if (processingService.notifications().length) {
    <div class="card">
        @for (notification of processingService.notifications(); track $index) {
            <div class="flex align-items-center flex-wrap">
                <li class="text-black-alpha-70 font-bold m-0 mr-2">{{ notification.message }}</li>
                <i
                    class="pi"
                    [ngClass]="{
                        'pi-check': notification.status() === 'complete',
                        'pi-times': notification.status() === 'error',
                        'pi-spin pi-spinner': notification.status() === 'processing'
                    }"></i>
            </div>
            <div class="flex flex-column pl-4">
                @for (feedback of notification.feedbacks(); track $index) {
                    <span class="bg-black-alpha-10 mb-1 w-fit">{{ feedback }}</span>
                }
            </div>
        }
    </div>
}
